import React, { useEffect } from 'react'
import { fetchItineraryOptionsConfig } from '../../store/itineraryOptions/itineraryOptions.actions'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import OptionsDialog from '../itinerary/OptionsDialog'
import useUIDisplay from '../ui/useUIDisplay'
import UserAccountIncentivePreferences from '../UserAccount/connectionIncentive/UserAccountIncentivePreferences'
import { useAction } from '../utils/react-redux'
import ItineraryOptions from './ItineraryOptions'

const ItineraryOptionsDialog = () => {
  const execFetchItineraryOptionsConfig = useAction(fetchItineraryOptionsConfig)
  const { isUIDisplayed } = useUIDisplay(UI_ELEMENTS.ITINERARY_OPTIONS_DIALOG)

  useEffect(() => {
    execFetchItineraryOptionsConfig()
  }, [isUIDisplayed])

  return (
    <OptionsDialog isDisplayed={isUIDisplayed} title="itinerary.options.title">
      <ItineraryOptions />
      <UserAccountIncentivePreferences />
    </OptionsDialog>
  )
}

export default withEmptyFallbackErrorBoundary(ItineraryOptionsDialog)
